import { apiClient } from "@/lib/api-client"
import {
  ApplicationComment,
  ApplicationCommentReactionEmoji,
  ApplicationCommentReactionSummary,
  MentionNotification,
} from "./dtos/ApplicationComment"

export const getApplicationComments = async (
  organizationId: string,
  applicationId: string,
): Promise<ApplicationComment[]> => {
  const response = await apiClient.get(
    `/organizations/${organizationId}/applications/${applicationId}/comments`,
  )
  return response.data
}

export const addApplicationComment = async (
  organizationId: string,
  applicationId: string,
  text: string,
  parentCommentId?: string,
): Promise<ApplicationComment> => {
  const response = await apiClient.post(
    `/organizations/${organizationId}/applications/${applicationId}/comments`,
    { text, parentCommentId },
  )
  return response.data
}

export const updateApplicationComment = async (
  organizationId: string,
  applicationId: string,
  commentId: string,
  text: string,
): Promise<ApplicationComment> => {
  const response = await apiClient.put(
    `/organizations/${organizationId}/applications/${applicationId}/comments/${commentId}`,
    { text },
  )
  return response.data
}

export const deleteApplicationComment = async (
  organizationId: string,
  applicationId: string,
  commentId: string,
): Promise<void> => {
  await apiClient.delete(
    `/organizations/${organizationId}/applications/${applicationId}/comments/${commentId}`,
  )
}

export const toggleApplicationCommentReaction = async (
  organizationId: string,
  applicationId: string,
  commentId: string,
  emoji: ApplicationCommentReactionEmoji,
): Promise<ApplicationCommentReactionSummary> => {
  const response = await apiClient.post(
    `/organizations/${organizationId}/applications/${applicationId}/comments/${commentId}/reactions`,
    { emoji },
  )
  return response.data
}

export const getMyCommentMentions = async (
  organizationId: string,
  applicationId: string,
): Promise<MentionNotification[]> => {
  const response = await apiClient.get(
    `/organizations/${organizationId}/applications/${applicationId}/comment-mentions/me`,
  )
  return response.data
}

export const dismissCommentMention = async (
  organizationId: string,
  applicationId: string,
  mentionId: string,
): Promise<void> => {
  await apiClient.post(
    `/organizations/${organizationId}/applications/${applicationId}/comment-mentions/${mentionId}/dismiss`,
  )
}
